import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountries } from '../store/countriesSlice';

// Cache duration in milliseconds (24 hours)
const CACHE_DURATION = 24 * 60 * 60 * 1000;

export const useCountries = () => {
  const dispatch = useDispatch();
  const { data: countries, loading, error, lastFetched } = useSelector(
    (state) => state.countries
  );

  useEffect(() => {
    // Check if we need to fetch countries
    const shouldFetch = 
      countries.length === 0 || 
      !lastFetched || 
      Date.now() - lastFetched > CACHE_DURATION;

    if (shouldFetch && !loading) {
      dispatch(fetchCountries());
    }
  }, [dispatch, countries.length, loading, lastFetched]);

  // Function to manually refresh countries
  const refreshCountries = () => {
    dispatch(fetchCountries());
  };

  return {
    countries,
    loading,
    error,
    refreshCountries,
  };
};

// Hook for searching countries with caching
export const useCountrySearch = () => {
  const { countries, loading } = useCountries();

  const searchCountries = (query) => {
    if (!query) return countries;
    
    return countries.filter(country => 
      country.label.toLowerCase().includes(query.toLowerCase())
    );
  };

  return {
    searchCountries,
    loading,
  };
};
